import { render, staticRenderFns } from "./update-supplier.vue?vue&type=template&id=5cea696c&"
import script from "./update-supplier.vue?vue&type=script&lang=js&"
export * from "./update-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports